<div class="modal-header blue">
  <h4 class="modal-title" id="modal-basic-title">Add Quick Filter</h4>
  <a href="javascript:void(0)" (click)="close()" class="modal-close-btn"></a>
</div>

<div class="modal-body">
  <form id="formQuickFilter" [formGroup]="formQuickFilter">
    <span class="input-label">Caption</span>

    <input
      type="text"
      class="input"
      placeholder="Enter Filter Name"
      formControlName="filterName"
      [class.invalid]="
        formQuickFilter.get('filterName')?.invalid &&
        formQuickFilter.get('filterName')?.touched
      "
    />

    <div
      class="invalid-feedback d-block text-left"
      *ngIf="
        formQuickFilter.get('filterName')?.invalid &&
        formQuickFilter.get('filterName')?.touched
      "
    >
      <span *ngIf="formQuickFilter.get('filterName')?.errors?.required"
        >This field is required</span
      >
      <span *ngIf="formQuickFilter.get('filterName')?.errors?.minlength">
        Min length:
        {{
          formQuickFilter.get('filterName')?.errors?.minlength['requiredLength']
        }}
      </span>
      <span *ngIf="formQuickFilter.get('filterName')?.errors?.maxlength">
        Max length:
        {{
          formQuickFilter.get('filterName')?.errors?.maxlength['requiredLength']
        }}
      </span>
      <span *ngIf="formQuickFilter.get('filterName')?.errors?.uniqueValue"
        >Quick Filter name should be unique</span
      >
    </div>

    <div class="d-flex mt-3">
      <checkbox formControlName="setAsDefault"> Set as default </checkbox>
    </div>
  </form>
</div>

<div class="modal-footer">
  <button
    type="submit"
    form="formQuickFilter"
    class="button w-80px ml-auto"
    [disabled]="formQuickFilter.invalid"
    (click)="save()"
  >
    Save
  </button>
</div>
